import React, {useState} from 'react';
import SectionHeading from '../../Common/SectionHeading';
import Image from 'next/image';
import * as Yup from 'yup';
import { useCommonEnquiryMutation } from '../../Store/Features/CommonFormAPI';
import { useRouter } from 'next/router';
import { encode } from '../../../utils/encrypt';
import CommonForm from '../../Common/CommonForm';

const ReadyToTalk = ({ title = null, slug=null }) => {

  const [LoadingStatus, setLoadingStatus] = useState(false);
  const [formAPICallBack, { isLoading, error }] = useCommonEnquiryMutation();
  
  const { push } = useRouter();
  const endpoint='enquiry/email-subscription'
  const fields = [
      {
          name: 'email',
          type: 'email',
          placeholder: 'Email',
          validation: Yup.string().email('Invalid email').required('Email is required'),
          customClass: 'md:col-span-6 col-span-12'
      }
  ];

  const options={
    btn_name:'Submit',
    btnContainerClass:'mt-0',
    btnCustomClass: 'bg-white text-[#1b5df3] px-5 py-2 rounded'
  }

  const handleSubmit=(values)=>{
    setLoadingStatus(true)
    values.name = 'DelveInsight Business Research';
    values.page_name = "Primary Research Services";
    values.form_name = 'ready-to-talk';
    values.source_url = window.location.href;
    values.source_url_from = document.referrer;
    values.datetime= new Date();

    formAPICallBack({
    data : { data: encode(values) },
    url : endpoint
    }).then((response) => {
        if (response) {
            if (response.data?.code == 200) {
                setTimeout(() => {
                    push('/thank-you');
                    setLoadingStatus(false)
                }, 1000);
            } else {
                alert(response.data.message)
            }

        } else {
            let res = {
                'message': "Error",
                'status': false
            }
        }
    }) 
  }

  return (
    <>
      <div className='w-11/12 mx-auto xl:max-w-screen max-w-screen-2xl'>
        <section className="bg-blue-500">
          <div className="mx-auto">
            <div className="flex flex-col lg:flex-row">
              <div className="p-10 lg:w-7/12">
                <>
                  {title && <SectionHeading title={title} customClass="text-left text-white" />}
                </>
                <p className="text-base text-white">
                  We work with ambitious leaders who want to define the future, not hide from it. Together, we achieve extraordinary outcomes.
                </p>
                <CommonForm 
                  fields={fields}
                  formTitle={'Primary Research Email Subscription'}
                  onSubmit={handleSubmit}
                  options={options}
                  captcha={ true }
                  isLoading={LoadingStatus}
                  page_name={'primary-research'}
                  form_name={'primary-research-email-subscription'}
                  slug={slug}
                />
              </div>
              <div className="pr-0 lg:w-5/12">
                <div className="mt-[-3em]">
                  <Image
                    priority={false}
                    width={2000}
                    height={2000}
                    src={process.env.IMG_CDN + 'img/primary-research/ready-to-talk.png'}
                    alt="Ready to talk"
                    className="hidden float-right w-10/12 lg:block h-80"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ReadyToTalk;